import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { SecondaryCriteriaForm } from "@common/secondaryCriteriaForm";
import { CogWheelIcon } from "@common/cogWheelIcon";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { ProjectElementsSecondaryCriteria } from "@scenes/projectElementsSecondaryCriteria";
import { Safeguard } from "@scenes/safeguard";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function CustomFields({
  project,
  template,
  attributes,
  isPending,
  onAttributeChange,
}: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <WorkspaceContext type="project" project={project}>
      <div className={styles.field}>
        <div className={styles.header}>
          <label className={styles.label}>
            {t("calendar.creationMenu.customFields")}
          </label>
          <Safeguard
            useCases={[UseCases.editProjectElementDetailsConfiguration]}
          >
            {({ canEditProjectElementDetailsConfiguration }) =>
              canEditProjectElementDetailsConfiguration ? (
                <div
                  className={styles.cogIconBox}
                  onClick={() =>
                    pushView({
                      key: UseCases.retrieveProjectElementDetailsConfiguration,
                      data: { project },
                    })
                  }
                >
                  <CogWheelIcon className={styles.cogIcon} />
                </div>
              ) : (
                <div />
              )
            }
          </Safeguard>
        </div>
        <div className={styles.secondaryCriteria}>
          <ProjectElementsSecondaryCriteria
            project={project}
            criteriaForms={template.reduce(
              (acc, criteria) => ({
                ...acc,
                [criteria.uuid]: (
                  <SecondaryCriteriaForm
                    criteria={criteria}
                    value={attributes[criteria.uuid] || ""}
                    disabled={isPending}
                    submit={(value) => onAttributeChange(criteria.uuid, value)}
                  />
                ),
              }),
              {},
            )}
          />
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { CustomFields };
